<template>
  <div class="container">
    <b-row>
      <div class="col-sm-12 d-flex justify-content-between">
          <img src="@/assets/images/logos/logo.svg" alt="logo" class="logo-modal">
          <div>
            <button class="btn btn-outline-info btn-sm " @click="$emit('closeModal')" v-b-tooltip.hover title="Close">
              <b-icon icon="x" />
            </button>
          </div>
      </div>
      <b-col><hr></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'modalHeader'
}
</script>
